import { Anulavel } from "@/types/gerais"
import { AtividadeDoProjeto } from "../atividadesDoProjeto/atividadesDoProjeto.modelos"

export const COR_PADRAO_PROJETO = "#59C2CF"

export type ListarProjetosComAtividadesDoProjeto = ListarProjetos

export interface ListarProjetos {
  id: string
  nomeProjeto: string
  codigo: string
  ativo: boolean
  deletado: boolean
  corHexadecimal: Anulavel<string>
  usuariosResponsaveis: string[]
  membros: MembroDoProjeto[]
  atividadesDoProjeto: AtividadeDoProjeto[]
}

export interface ProjetosSimples {
  id: string
  nomeProjeto: string
  codigo: string
  ativo: boolean
  deletado: boolean
  corHexadecimal: Anulavel<string>
  usuariosResponsaveis: string[]
  membros: MembroSimples[]
}

export interface ProjetosComAtividadesDoProjeto {
  id: string,
  nomeProjeto: string,
  atividadesDoProjeto?: AtividadeDoProjeto[]
  membros?: MembroDoProjeto[]
}

export interface ParamsProjeto {
  id?: string
  codigo?: string
  nomeProjeto?: string
  ativo?: string
  deletado?: string
  grupo_de_projetos?: string
  usuariosResponsaveis?: string[]
  "ordenar-por"?: string[]
  pagina?: number
  "por-pagina"?: number
}

export type MembroDoProjeto = {
  idUsuario: string
  codigo: string
  nome?: string
  emailUsuario?: Anulavel<string>
  foto?: string
}

type MembroSimples = {
  idUsuario: string
  codigo: string
}

export interface CriarProjeto {
  nomeProjeto: string,
  idsUsuariosResponsaveis: string[],
  membros: MembroDoProjeto[],
  corHexadecimal: string,
  codigo: string,
}
export type EditarProjeto = CriarProjeto
